import Icon from "@mui/material/Icon"
import Tooltip from "@mui/material/Tooltip"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import colors from "assets/theme/base/colors"
import rgba from "assets/theme/functions/rgba"
import PrettySwitch from "../PrettySwitch"

const ENTITY_LABEL = {}

// A small map so each entity gets a recognisable, non-decorative glyph.
const ENTITY_ICON = {
  order: "shopping_cart",
  purchase: "receipt_long",
  payment: "payments",
}

const Meta = ({ label, value }) => (
  <MDBox>
    <MDTypography
      variant="caption"
      color="text"
      display="block"
      sx={{ opacity: 0.7 }}
    >
      {label}
    </MDTypography>
    <MDTypography variant="caption" fontWeight="medium" color="dark">
      {value}
    </MDTypography>
  </MDBox>
)

const RuleListCard = ({
  rule,
  selected,
  onSelect,
  entityLabelMap,
  onToggleActive,
  togglingActive,
}) => {
  const labels = entityLabelMap || ENTITY_LABEL
  const entityLabel = labels[rule.entityType] || rule.entityType
  const stepCount = rule.stepsCount || 0
  const lastModified = rule.updatedAt ? new Date(rule.updatedAt).toLocaleDateString() : "—"

  return (
    <MDBox
      p={2}
      mb={1.5}
      borderRadius="lg"
      bgColor="white"
      sx={{
        cursor: "pointer",
        transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        border: `1px solid ${colors.grey[300]}`,
        "&:hover": { boxShadow: 3, borderColor: rgba(colors.info.main, 0.4) },
        ...(selected && {
          bgcolor: rgba(colors.info.main, 0.06),
          borderColor: colors.info.main,
          boxShadow: `inset 0 0 0 1px ${colors.info.main}`,
        }),
      }}
      onClick={onSelect}
    >
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={1}
        mb={1.5}
      >
        <MDBox display="flex" alignItems="center" gap={1.25} sx={{ minWidth: 0 }}>
          <MDBox
            width="2rem"
            height="2rem"
            minWidth="2rem"
            borderRadius="md"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              backgroundColor: rgba(colors.info.main, 0.1),
              color: colors.info.main,
            }}
          >
            <Icon fontSize="small">{ENTITY_ICON[rule.entityType] || "rule"}</Icon>
          </MDBox>
          <MDTypography
            variant="button"
            fontWeight="bold"
            color="dark"
            title={rule.name}
            sx={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              lineHeight: 1.3,
            }}
          >
            {rule.name}
          </MDTypography>
        </MDBox>
        <MDBox display="flex" alignItems="center" flexShrink={0}>
          {onToggleActive && (
            <Tooltip title={rule.isActive ? "Deactivate rule" : "Activate rule"}>
              <span onClick={(e) => e.stopPropagation()}>
                <PrettySwitch
                  checked={!!rule.isActive}
                  disabled={togglingActive}
                  onChange={(e) => onToggleActive(rule, e.target.checked)}
                />
              </span>
            </Tooltip>
          )}
        </MDBox>
      </MDBox>

      <MDBox
        display="grid"
        gridTemplateColumns="1fr 1fr"
        gap={1}
        sx={{ rowGap: 1 }}
      >
        <Meta label="Applies to" value={entityLabel} />
        <Meta label="Steps" value={`${stepCount} step${stepCount !== 1 ? "s" : ""}`} />
        <Meta label="Version" value={rule.version != null ? `v${rule.version}` : "—"} />
        <Meta label="Last modified" value={lastModified} />
      </MDBox>
    </MDBox>
  )
}

export default RuleListCard
